module.exports = __webpack_public_path__ + "static/img/MC-LH.ea8da4ab.jpg";